import { Route } from "react-router-dom";
import PageTitle from "../components/PageTitle";
import Inbox from "../pages/Inbox";
import ProtectedRouteV2 from "./ProtectedRouteV2";

const inboxRoutes = (
  <Route element={<ProtectedRouteV2 />}>
    <Route
      path="/inbox"
      element={
        <>
          <PageTitle title="Inbox | TailAdmin - Tailwind CSS Admin Dashboard Template" />
          <Inbox />
        </>
      }
    />
  </Route>
);

export default inboxRoutes;
